export const defaultComparer = (a, b) => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};


// WEBPACK FOOTER //
// ./src/utils/compare.js